import { motion } from "framer-motion";
import {
  FaWhatsapp,
  FaReact,
  FaMobileAlt,
  FaGlobe,
} from "react-icons/fa";

export default function ReferenceBanner({
  phoneNumber = "919996407289",
  message = "Hi! I need a website or app.",
}) {
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  const services = [
    { icon: FaGlobe, label: "Business Websites" },
    { icon: FaReact, label: "React & Next.js" },
    { icon: FaMobileAlt, label: "Android & iOS Apps" },
  ];

  const blobAnimation = {
    y: [0, -20, 0],
    transition: { duration: 6, repeat: Infinity, ease: "easeInOut" },
  };

  return (
    <section className="relative overflow-hidden mb-10 ">

      <div className="container relative max-w-8xl m-auto px-4 sm:px-0">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          viewport={{ once: true, margin: "-40px" }}
          className="flex flex-col items-center justify-between gap-10 rounded-3xl border border-white/20 bg-gradient-to-br from-blue-600 via-indigo-700 to-purple-800 p-8 backdrop-blur-xl lg:flex-row lg:px-12"
        >
          {/* Left content */}
          <div className="max-w-3xl text-white">
            <span className="inline-block rounded-full py-2 text-sm font-semibold uppercase tracking-wider">
              Freelance Full Stack Developer
            </span>

            <h2 className="mt-5 text-3xl font-bold leading-tight md:text-5xl">
              Need a Website or Mobile App?
            </h2>

            <p className="mt-4 text-lg text-white/90">
              I build fast, modern, and scalable websites, web applications, and
              Android & iOS apps for businesses, startups, and agencies.
            </p>

            <div className="mt-6 flex flex-wrap gap-5 text-white/90">
              {services.map(({ icon: Icon, label }) => (
                <div key={label} className="flex items-center gap-2">
                  <Icon className="text-xl" aria-hidden="true" />
                  <span>{label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* CTA Button */}
          <motion.a
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat on WhatsApp"
            className="inline-flex items-center gap-3 rounded-full bg-white px-8 py-4 text-lg font-semibold text-gray-800 shadow-2xl transition-colors hover:bg-gray-100 focus:outline-none focus:ring-4 focus:ring-white/50"
          >
            <FaWhatsapp className="text-3xl text-green-500" aria-hidden="true" />
            Chat on WhatsApp
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
}